module.exports = __webpack_public_path__ + "img/duck.961acb67.svg";